import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import SigmaModal from "security-app/components/SigmaRules/ImportRulesModal/SigmaModal";
import { useGetSigmaRule, sigmaRuleKey } from "security-app/hooks/useSigmaAPI";
import { useModalContext } from "common/contexts";
import { ConfirmDialog } from "security-app/components/common/Modal";
import { eventDefinitionsKey } from "security-app/hooks/useSecurityEventsAPI";
function EditSigmaEventDefinition() {
  const queryClient = useQueryClient();
  const { entity: ruleId, setModal, setEntity } = useModalContext();
  const { rule, loadingRule } = useGetSigmaRule(ruleId);
  const onClose = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [eventDefinitionsKey]
    });
    queryClient.invalidateQueries({
      queryKey: [sigmaRuleKey]
    });
    setModal(null);
    setEntity(null);
  }, [setEntity, setModal, queryClient]);
  if (!rule && !loadingRule) {
    return /* @__PURE__ */ React.createElement(
      ConfirmDialog,
      {
        show: true,
        onConfirm: onClose,
        confirmText: "Close",
        noCancelButton: true,
        type: "danger",
        title: "Edit Sigma Event Definition"
      },
      /* @__PURE__ */ React.createElement("p", null, 'A Sigma Rule with ID: "', ruleId, '" could not be found.')
    );
  }
  return loadingRule ? null : /* @__PURE__ */ React.createElement(SigmaModal, { rule, onConfirm: onClose, onCancel: onClose });
}
export default EditSigmaEventDefinition;
